import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";
import { FileUpload } from "../FileUpload";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { authApi, formatApiErrorDetail } from "../../lib/authApi";

export const DrawingIntake = ({ onCancel }) => {
  const [title, setTitle] = useState("");
  const [files, setFiles] = useState([]);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const create = async (event) => {
    event.preventDefault(); setSaving(true);
    try {
      const { data } = await authApi.post("/rfqs", { title, analysis_file_ids: files.map(f => f.id) });
      navigate(`/portal/rfqs/${data.id}/understanding`);
    } catch (error) { toast.error(formatApiErrorDetail(error.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return <form onSubmit={create} className="max-w-3xl space-y-6 py-4" data-testid="s4-drawing-intake">
    <Button type="button" variant="ghost" onClick={onCancel} data-testid="s4-intake-back"><ArrowLeft className="h-4 w-4 mr-2" />RFQs</Button>
    <h2 className="font-heading text-lg font-semibold" data-testid="s4-intake-title">RFQ from drawings</h2>
    <div className="space-y-2"><Label htmlFor="drawing-rfq-title">RFQ title</Label><Input id="drawing-rfq-title" required maxLength={200} value={title} onChange={e => setTitle(e.target.value)} data-testid="s4-intake-title-input" /></div>
    <FileUpload files={files} onChange={setFiles} testId="s4-intake-upload" maxFiles={3} />
    <p className="text-sm text-muted-foreground" data-testid="s4-intake-limits">Analysis: up to 3 documents, 8 PDF/image pages total, 20MB per document. Other CAD formats require manual engineering review.</p>
    <Button type="submit" disabled={saving || !files.length || !title.trim()} className="rounded-full" data-testid="s4-intake-create">
      {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <ArrowRight className="h-4 w-4 mr-2" />}Create review draft
    </Button>
  </form>;
};